<template>
  <b-modal
    v-model="visible"
    title="Thêm nhà cung cấp phụ"
    size="md"
    hide-footer
    @hidden="onHidden"
  >
    <b-form @submit.prevent="onSubmit">
      <b-form-group>
        <template #label>
          <label>Tên KH/NCC phụ: <span class="text-danger">*</span></label>
        </template>
        <b-form-input
          size="sm"
          v-model.trim="form.fullName"
          placeholder="Nhập tên"
          :state="submitted && !form.fullName ? false : null"
          autofocus
        />
        <b-form-invalid-feedback>Vui lòng nhập tên</b-form-invalid-feedback>
      </b-form-group>

      <b-row>
        <b-form-group class="col-6">
          <template #label><label>Điện thoại:</label></template>
          <b-form-input
            size="sm"
            v-model.trim="form.phoneNo"
            placeholder="Nhập số điện thoại"
          />
        </b-form-group>
        <b-form-group class="col-6">
          <template #label>
            <label>Mã nội bộ: <span class="text-danger">*</span></label>
          </template>
          <b-form-input
            size="sm"
            v-model.trim="form.code"
            placeholder="Nhập mã nội bộ"
            :state="submitted && !form.code ? false : null"
          />
          <b-form-invalid-feedback>Vui lòng nhập mã nội bộ</b-form-invalid-feedback>
        </b-form-group>
      </b-row>

      <b-form-group>
        <template #label><label>Mã số thuế:</label></template>
        <b-form-input
          size="sm"
          v-model.trim="form.taxCode"
          placeholder="Nhập mã số thuế"
        />
      </b-form-group>

      <b-form-group>
        <template #label><label>Email:</label></template>
        <b-form-input
          size="sm"
          type="email"
          v-model.trim="form.email"
          placeholder="vd: contact@company.vn"
        />
      </b-form-group>

      <b-form-group>
        <template #label><label>Địa chỉ:</label></template>
        <b-form-textarea
          size="sm"
          v-model="form.address"
          placeholder="Nhập địa chỉ"
          :rows="2"
        />
      </b-form-group>

      <div class="d-flex justify-content-end mt-3">
        <b-button
          size="sm"
          variant="outline-secondary"
          class="mr-2"
          @click="visible = false"
          :disabled="isSubmitting"
        >
          Hủy
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          type="submit"
          :disabled="isSubmitting"
        >
          <span v-if="isSubmitting">
            <b-spinner small class="mr-1" />Đang lưu...
          </span>
          <span v-else>Lưu</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';

export default {
  name: 'SubSupplierFormModal',

  props: {
    parentId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      visible: true,
      submitted: false,
      isSubmitting: false,
      form: {
        fullName: '',
        phoneNo: '',
        code: '',
        taxCode: '',
        email: '',
        address: '',
      },
    };
  },

  methods: {
    onHidden() {
      this.$emit('close');
    },

    async onSubmit() {
      this.submitted = true;
      if (!this.form.fullName || !this.form.code) return;

      this.isSubmitting = true;
      try {
        const payload = {
          fullName: this.form.fullName,
          parentId: this.parentId,
          code: this.form.code,
        };
        if (this.form.phoneNo) payload.phoneNo = this.form.phoneNo;
        if (this.form.taxCode) payload.taxCode = this.form.taxCode;
        if (this.form.email) payload.email = this.form.email;
        if (this.form.address) payload.address = this.form.address;

        await ApiService.post('v1/customers', payload);
        makeToastSuccess('Thêm NCC phụ thành công!');
        this.$emit('created');
        this.visible = false;
      } catch (err) {
        const msg = err?.response?.data?.message || err?.message || 'Có lỗi xảy ra';
        makeToastFaile(msg);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
